import { render } from "./export-data-modal.vue?vue&type=template&id=79b98244&ts=true"
import script from "./export-data-modal.ts?vue&type=script&lang=ts"
export * from "./export-data-modal.ts?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__